import { contextItemKey, type ComposerStore } from "@/composer/schema"
import { pathKey } from "./path-key"
import { renamedDirectory } from "./rename-path"

export function renameDraftComposer(store: ComposerStore, previous: string, directory: string): ComposerStore {
  return {
    ...store,
    prompt: store.prompt.map((part) => {
      if (part.type === "image")
        return { ...part, sourcePath: part.sourcePath && renamedDirectory(part.sourcePath, previous, directory) }
      if (part.type !== "file" && part.type !== "path") return part
      const next = { ...part, path: renamedDirectory(part.path, previous, directory) }
      if (next.type !== "file") return next
      return {
        ...next,
        url: next.url && renameFileUrl(next.url, previous, directory),
        source:
          next.source && "path" in next.source
            ? { ...next.source, path: renamedDirectory(next.source.path, previous, directory) }
            : next.source,
      }
    }),
    context: {
      items: store.context.items.map((item) => {
        const next = { ...item, path: renamedDirectory(item.path, previous, directory) }
        return { ...next, key: contextItemKey(next) }
      }),
    },
  }
}

function renameFileUrl(value: string, previous: string, directory: string) {
  if (!value.startsWith("file:") || !URL.canParse(value)) return value
  const url = new URL(value)
  // Persisted attachments can contain older, malformed URL escapes. Keep those unchanged.
  const pathname = (() => {
    try {
      return decodeURIComponent(url.pathname)
    } catch {
      return undefined
    }
  })()
  if (!pathname) return value
  const source = url.hostname
    ? `//${url.hostname}${pathname}`
    : /^\/[a-z]:\//i.test(pathname)
      ? pathname.slice(1)
      : pathname
  const next = renamedDirectory(source, previous, directory)
  if (next === source) return value
  const normalized = pathKey(next)
  url.pathname = url.hostname ? normalized.slice(2 + url.hostname.length) : normalized
  return url.href
}
